import { SeriesPointXY } from '@bitrise/bitviz';

export default (series: SeriesPointXY[]): SeriesPointXY | null => {
  for (let i = series.length - 1; i >= 0; i -= 1) {
    if (series[i].y !== null) {
      return series[i];
    }
  }

  return null;
};
